<div class="flex-1 min-h-0 relative h-full flex flex-col">
  <div class="flex-1 min-h-0 flex items-center justify-center overflow-hidden">
    @if (showVideoLayout()) {
      <app-call-video-layout
        class="w-full h-full"
        [isFullscreen]="isFullscreen()"
        (stopShareEvt)="handleToggleShareScreen()"
      ></app-call-video-layout>
    } @else if (isInCall()) {
      <app-call-audio-layout
        [isFullscreen]="isFullscreen()"
        class="w-full h-full"
      ></app-call-audio-layout>
    }
  </div>
  <!-- btn action -->
  @if (isInCall()) {
    <app-call-action-bar
      [showCallMeta]="showVideoLayout() && isFullscreen() && !isOpenPip()"
      (closeModalEvt)="handleClose()"
      (toggleCamEvt)="handleToggleCam()"
      (toggleShareScreenEvt)="handleToggleShareScreen()"
    ></app-call-action-bar>
  }
</div>

@if (showSwitchCallModal()) {
  <app-call-confirm-modal
    title="Chuyển sang Video Call?"
    description="Bạn muốn chuyển cuộc gọi thoại thành cuộc gọi video?"
    cancelText="Hủy"
    confirmText="Mở camera"
    (cancelEvt)="showSwitchCallModal.set(false)"
    (confirmEvt)="showSwitchCallModal.set(false); handleSwitchCallType(); executeToggleCam()"
  ></app-call-confirm-modal>
}

@if (showConfirmShareScreenModal()) {
  <app-call-confirm-modal
    title="Bắt đầu chia sẻ"
    description="Điều này sẽ dừng chia sẻ màn hình của người khác. Bạn có muốn tiếp tục không?"
    cancelText="Hủy"
    confirmText="Tiếp tục"
    (cancelEvt)="showConfirmShareScreenModal.set(false)"
    (confirmEvt)="showConfirmShareScreenModal.set(false); toggleScreenShare()"
  ></app-call-confirm-modal>
}
